import { InjectionToken, LOCALE_ID } from '@angular/core';

import { SupportedLocale, environment } from '@env';

export const ASSETS_DIR: InjectionToken<string> = new InjectionToken('ASSETS_DIR');

const buildAssetsDir = (localeId: SupportedLocale): string => `${ environment.production ? `/${ localeId }` : '' }/assets`;

export function provideAssetsDir() {
  return {
    provide: ASSETS_DIR,
    useFactory: (localeId: SupportedLocale) => buildAssetsDir(localeId),
    deps: [ LOCALE_ID ]
  };
}